import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-select-img',
  template: `
    <mat-form-field appearance="outline">
      <mat-label>{{ props.label }}</mat-label>
      <mat-select
        (openedChange)="onOpenedChange($event)"
        [formControl]="formControl" 
        [formlyAttributes]="field">
        <mat-select-trigger>
          @if (formControl.value) {
            <img
              [src]="getImage(formControl.value)"
              width="20"
              style="margin-right: 8px"
              [alt]="getLabel(formControl.value)"/>
          }
          <span>{{ getLabel(formControl.value) }}</span>
        </mat-select-trigger>

        @for (option of getOptions; track option) {
          <mat-option [value]="option.value">
            <div class="align">
              <img
                [src]="getImage(option.value)"
                width="20"
                [alt]="option.label"
                style="margin-right: 8px"
              />
              <span>{{ option.value }}</span>
            </div>
          </mat-option>
        }
      </mat-select>
      <mat-error>
        <formly-validation-message [field]="field"></formly-validation-message>
      </mat-error>
    </mat-form-field>
  `,
  styles: `
    mat-select-trigger, .align {
      display: flex;
      justify-content: start;
      align-items: center;
    }
  `,
  standalone: false
})
export class FormlySelectImgComponent extends FieldType<FieldTypeConfig> {


  get getOptions(): any[] {
    return !!this.props.options ? this.props.options as any[] : [];
  }

  onOpenedChange(opened: boolean) {
    if (opened && this.props.onOpen) {
      this.props.onOpen(this.field);
    }
  }

  getLabel(value: any): string {
    const options: any[] = this.props.options as any;
    const found = options?.find((opt: any) => opt.value === value);
    return found?.label || value;
  }

  getImage(value: any): string {
    const options: any[] = this.props.options as any;
    const found = options?.find((opt: any) => opt.value === value);
    return found?.img || '';
  }
}
